import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import type { SpacerBlockInterface } from '~/types/AppData/PageBuilder/SpacerBlockInterface';

const spacerClass = cva('', {
  variants: {
    size: {
      sm: 'h-4',
      md: 'h-8',
      lg: 'h-16',
      xl: 'h-32',
    },
  },
});

export default component$<SpacerBlockInterface['props']>(
  ({ size }): JSX.Element => {
    return (
      <div
        class={spacerClass({
          size,
        })}
      />
    );
  }
);
